import streamingAsBackbone from '../decks/event-talks/streaming-as-backbone/deck';
import currentSummitLondonBooth from '../decks/booth-decks/current-summit-london-booth/deck';
import dataAiSummitBooth from '../decks/booth-decks/data-ai-summit-booth/deck';
import contextStreams from '../decks/event-talks/context-streams/deck';
import fromTopicsToTablesBudapest from '../decks/event-talks/from-topics-to-tables-budapest/deck';
import brokerSideFilterForKafka from '../decks/event-talks/broker-side-filter-for-kafka/deck';
import componentGallery from '../decks/product-demos/component-gallery/deck';
import orcaFiveLessons from '../decks/event-talks/orca-five-lessons/deck';
import aiConferenceBooth from '../decks/booth-decks/ai-conference-booth/deck';
import orcaIntro from '../decks/event-talks/orca-intro/deck';
import type { Deck, DeckCategory } from './framework/types';

export const decks: readonly Deck[] = [
  streamingAsBackbone,
  currentSummitLondonBooth,
  dataAiSummitBooth,
  contextStreams,
  fromTopicsToTablesBudapest,
  brokerSideFilterForKafka,
  componentGallery,
  orcaFiveLessons,
  aiConferenceBooth,
  orcaIntro,
];

export const decksBySlug: ReadonlyMap<string, Deck> = new Map(
  decks.map(d => [d.slug, d] as const),
);

/** Display order of category sections on the home page. */
export const categoryOrder: readonly DeckCategory[] = [
  'event-talks',
  'booth-decks',
  'product-demos',
];

/** Human-readable label + one-line blurb for each category. */
export const categoryMeta: Record<DeckCategory, { name: string; blurb: string }> = {
  'event-talks': {
    name: 'Event Talks',
    blurb: 'Conference and meetup decks delivered by StreamNative speakers.',
  },
  'booth-decks': {
    name: 'Booth Decks',
    blurb: 'Conference booth decks — one StreamNative pitch, tuned per event.',
  },
  'product-demos': {
    name: 'Product Demos',
    blurb: 'Live demo walkthroughs of StreamNative products.',
  },
};

/** Single source of truth for whether a deck bypasses the Okta gate. */
export function isDeckPublic(deck: Deck): boolean {
  return deck.visibility === 'public';
}
